module.exports = __webpack_public_path__ + "static/img/logo5.5aabc3c4.png";